import { LiteralExpression } from './LiteralExpression.js';
export class BooleanExpression extends LiteralExpression {
    parseValue(value) {
        return JSON.parse(value);
    }
}
//# sourceMappingURL=BooleanExpression.js.map